import moment from 'moment';

const startOfMonth = moment().startOf('month').format('YYYY-MM-DD');
const usageData = {
  orgId: 123,
  usage: {
    [startOfMonth]: {
      automatedPRs: 812,
      limit: 1000
    }
  }
};

export default usageData;
